"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BoxContainerWidths = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _AppTheme = _interopRequireDefault(require("../../../../AppTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var widthMap = {
  auto: "auto",
  xs: _AppTheme.default.spacing(96),
  sm: _AppTheme.default.spacing(128),
  md: _AppTheme.default.spacing(180)
};

var BoxContainer = function BoxContainer(_ref) {
  var maxWidth = _ref.maxWidth,
      children = _ref.children;
  var media = (0, _core.useMediaQuery)(_AppTheme.default.breakpoints.down('xs'));
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    px: media ? 2 : 2.5,
    maxWidth: widthMap[maxWidth],
    ml: "auto",
    mr: "auto"
  }, children);
};

BoxContainer.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.node]),
  maxWidth: _propTypes.default.oneOf(["auto", "xs", "sm", "md"])
};
BoxContainer.defaultProps = {
  children: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null),
  maxWidth: "auto"
};
var BoxContainerWidths = ["auto", "xs", "sm", "md"];
exports.BoxContainerWidths = BoxContainerWidths;
var _default = BoxContainer;
exports.default = _default;